import React from "react";
import { siteData } from "../data/mockData";

const HeroSection = () => {
  const { hero } = siteData;

  return (
    <section
      id="home"
      className="w-full bg-white py-12 md:py-20 px-6 md:px-16 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row items-center gap-10 md:gap-16">
        {/* Left Content */}
        <div className="flex-1 max-w-xl">
          <h1 className="font-poppins font-bold text-[2.5rem] md:text-[3rem] leading-tight text-[#1a1a1a] mb-6">
            {hero.titleLine1}
            <br />
            {hero.titleLine2}{" "}
            <span className="text-[#1CA0B9]">{hero.highlight}</span>
          </h1>

          <p className="font-poppins text-[#666] text-sm md:text-base italic mb-8">
            {hero.subtitle}
          </p>

          <p className="font-poppins text-[#555] text-sm md:text-[15px] leading-relaxed">
            At{" "}
            <span className="text-[#1CA0B9] font-medium">
              Anish Total Dental Care
            </span>
            , we believe that every smile is unique and deserves the best care.
            With a legacy of providing exceptional dental services to our
            community, we are committed to helping you achieve and maintain a
            healthy, beautiful smile.
          </p>
        </div>

        {/* Right Image */}
        <div className="flex-1 relative flex justify-center">
          <div className="relative w-full max-w-[550px]">
            {/* Background shape - full coverage */}
            <div className="absolute top-0 right-0 w-[110%] h-full bg-[#D6F0F0] rounded-bl-[60px] -z-0" />
            <img
              src={hero.image}
              alt="Doctor"
              className="relative z-10 w-full h-auto object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
